import { useState, useEffect } from "react";
import { Hint, RadialChart } from "react-vis";
import { Card } from "@material-ui/core";
import UserService from "../services/user-service";
import "react-vis/dist/style.css";
import { Col, Row } from "react-bootstrap";
import useWindowSize from "../hooks/useWindowSize";
import ExpenseTrackerChart from "./Charts/ExpenseTrackerChart";
var total = 0;
var cardData1: any = [];
var cardData2: any = [];

const colors = [
  "#F39292",
  "#7964D9",
  "#EB6F2D",
  "#98B514",
  "#0DA4B5",
  "#FFD436",
  "#FAAC02",
  "#EA4147",
  "#FC6897",
  "#006895",
];

export function createData(name, date, amount, site, category, note) {
  return { name, date, amount, site, category, note };
}

export function createData2(name, amount, index) {
  var colorindex = 0;
  if (index >= colors.length) {
    colorindex = index % colors.length;
  } else {
    colorindex = index;
  }
  return {
    label: name || 'Unspecified',
    angle: amount,
    subLabel: amount,
    color: colors[colorindex],
  };
}

export function percentage(amount, total) {
  const temp = ((parseFloat(amount) / total) * 100).toFixed(1);
  // console.log("@@@:", amount, total);
  return temp + "%";
}

export function round(amount) {
  return "$" + parseFloat(amount).toFixed(2);
}

const rows = [
  createData(
    "Hand plane",
    "4/9/21",
    "$10.00",
    "Lowe's",
    "Workshop tools",
    "Replacement"
  ),
  createData("Oak 4 x 4 x 4", "4/21/21", "$37.00", "Lowe's", "Lumber", 0),
  createData(
    "Dado blade",
    "5/10/21",
    "$50.00",
    "Lowe's",
    "Workshop tools",
    "Drawer"
  ),
  createData("Sandpaper", "6/9/21", "$10.00", "Lowe's", "Supplies", "Bench"),
];

function PieChart(props) {
  const [, setToLoading] = useState(true);
  const [nrows, setnRows] = useState(rows);
  const [value, setValue] = useState<any>({});
  const categoryType: any = props.categoryType;
  total = 0;
  const { width = 0 } = useWindowSize();

  useEffect(() => {
    UserService.getExpense().then((response) => {
      const filtered = UserService.getSpecificExpense(
        response.data.expense,
        props.stream + 1
      );
      setnRows(filtered.reverse());
      setToLoading(false);
    });
  }, [props.stream,props.reloadAPI]);

  var dict = {};
  Array.from(nrows).map(function (e) {
    const amount = parseFloat(e.amount);
    switch (categoryType) {
      case "note":
        e.site in dict
          ? (dict[e.site] = dict[e.site] + amount)
          : (dict[e.site] = amount);
        break;
      case "name":
        e.name in dict
          ? (dict[e.name] = dict[e.name] + amount)
          : (dict[e.name] = amount);
        break;
      case "category":
        e.category in dict
          ? (dict[e.category] = dict[e.category] + amount)
          : (dict[e.category] = amount);
        break;
      default:
        return null;
    }
  });

  if (nrows.length === 0) {
    return <div></div>;
  }

  cardData1 = Object.keys(dict).slice(0, Object.keys(dict).length / 2);
  cardData2 = Object.keys(dict).slice(
    Object.keys(dict).length / 2,
    Object.keys(dict).length
  );
  return (
    <Row className="justify-content-center mb-5">
      <Col xl={8} lg={6} md={12} className="d-flex justify-content-center">
        <div>
          <h4 className="graph-header">
            View Percentage Breakdown of Expenses
          </h4>
          <ExpenseTrackerChart
            data={Object.keys(dict).map((nrow, index) => {
              total += dict[nrow];
              return createData2(nrow, dict[nrow], index);
            })}
          />
        </div>
      </Col>
      <Col xl={4} lg={5} md={12}>
        <div className="card-section">
          {Object.keys(dict).length <= 8 ? (
            <Card className="card-content">
              <div className="pl-2 card-main-content">
                {Object.keys(dict).map((nrow, index) => {
                  let data = createData2(nrow, dict[nrow], index);
                  return (
                    <>
                      <div className="piechart-legends" key={index}>
                        <p
                          style={{
                            // boxes of color in the legend
                            backgroundColor: data.color,
                            width: 20,
                            height: 20,
                            marginBottom: 10,
                          }}
                        />
                        <p className="name-content">
                          {percentage(data.subLabel, total)} -&nbsp;
                          {data.label.length > 10
                            ? data.label.slice(0, 10) + "..."
                            : data.label}
                        </p>
                      </div>
                    </>
                  );
                })}
              </div>
            </Card>
          ) : (
            <div className="d-flex justify-content-around mt-3">
              <Card className="card-content mr-4 mt-3">
                <div className="pl-2 card-main-content">
                  {cardData1.map((nrow, index) => {
                    let data = createData2(nrow, dict[nrow], index);
                    return (
                      <>
                        <div className="piechart-legends" key={index}>
                          <p
                            style={{
                              // boxes of color in the legend
                              backgroundColor: data.color,
                              width: 20,
                              height: 20,
                              marginBottom: 10,
                            }}
                          />
                          <p className="name-content">
                            {percentage(data.subLabel, total)} -
                            {data.label.length > 10
                              ? data.label.slice(0, 10) + "..."
                              : data.label}
                          </p>
                        </div>
                      </>
                    );
                  })}
                </div>
              </Card>
              <Card className="card-content mr-4 mt-3">
                <div className="pl-2 card-main-content">
                  {cardData2.map((nrow, index) => {
                    let data = createData2(
                      nrow,
                      dict[nrow],
                      index + cardData1.length
                    );
                    return (
                      <>
                        <div className="piechart-legends" key={index}>
                          <p
                            style={{
                              // boxes of color in the legend
                              backgroundColor: data.color,
                              width: 20,
                              height: 20,
                              marginBottom: 10,
                            }}
                          />
                          <p className="name-content">
                            {percentage(data.subLabel, total)} -
                            {data.label.length > 10
                              ? data.label.slice(0, 10) + "..."
                              : data.label}
                          </p>
                        </div>
                      </>
                    );
                  })}
                </div>
              </Card>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
}

export default PieChart;
